module.exports = __webpack_public_path__ + "static/media/Deoxys_gaussian2.581252e8.png";